import * as Config from '../config';
import useDebouncedEffect from './useDebouncedEffect';
import { useState, useEffect, useCallback, useContext, useRef } from "react";
import { ReactReduxContext } from 'react-redux';

import {
  setStackAutomix
} from "../components/library/automix/redux/actions/index";

import {
  setSelectedItems, setReadyBoostFilters,
  setStoreListRedux, updateStorePlaylists,
  clearDropbox
} from "../actions/index";

const axios = require('axios');

const NB_ITEMS_BY_DEBOUNCE = 10; //10 items / 20fps / 50ms
let globalStackItems = [];
let globalStackFrom = [];
let globalNext = []; //null;
const defaultStoreList = {
  itemsFull: null,
  total: 0,
  items: null,
  count: 0,
  next: null
}
const useApiOrLocalV2 = (
  api, path = null, data = [], idParent, from = null, isBoost = false, createStore = false,
  isBaseRootApi = true, customFormatData = null, loadMoreWithApi = true, cache = true) => {
  const { store } = useContext(ReactReduxContext)
  const { getState, dispatch } = store;
  const [storeList, setStoreList] = useState(defaultStoreList);
  const lockedRef = useRef(false);

  useEffect(() => {
    if (storeList.total > 0) {
      setStoreList(defaultStoreList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]) // Warning - storeList.total but need to be removed

  useEffect(() => {
    let source = null;
    unSelectedItems();
    if (path) {
        if (path.includes('LOCAL|')) { // No request again if local order by | Filters
          const partx = path.replace(`LOCAL|`, ``).split(`&`);
          let order = ``;
          const filters = partx.reduce( (base, x) => {
            if (x.length > 0 && !x.includes(`order_by`)) {
              const [type, value] = x.split(`=`);
              base.push({type, value});
            } else if (x.length > 0 && x.includes(`order_by`)) {
              const [, valueo] = x.split(`=`);
              order = valueo;
            }
            return base;
          }, []);

          const asc = order.includes('-') ? false : true ;
          const property = order.includes('-') ? order.substring(1, order.length) : order;

          if (storeList.itemsFull.length > 0) {
            let newItems = [...storeList.itemsFull].filter( x => filters.every( f => {
              const strict = (f.type === `key_camelot` || f.type === `genre_s`);
              return x[f.type] && x[f.type].toLowerCase().slice(0, strict ? f.value.length : x[f.type].length ).includes(f.value.toLowerCase())
            } ));
            if (property === `key_camelot`) {
              newItems.sort(Config.sortAlphaNumeric(property, asc));
            } else if (property === `bpm`) {
              newItems.sort(Config.sortNumeric(property, asc));
            } else {
              newItems.sort(Config.sortAlpha(property, asc));
            }
            const ii = [...newItems].splice(0, NB_ITEMS_BY_DEBOUNCE);
            setStoreList({
              ...storeList,
              items: [...ii],
              count: NB_ITEMS_BY_DEBOUNCE
            })
            globalStackItems[idParent] = newItems;

            if (from) {
              dispatch(setStackAutomix({ idPlaylist: idParent, tracks: [...newItems], from, active: 0, next: null }));
            }
          }
        } else {

          source = axios.CancelToken.source();
          const isCache = ( cache && !path.includes('/v4/my/playlists'));
          api.getFromApi(path, isCache, source.token, isBaseRootApi ? Config.API_URL : Config.API_SEARCH_URL).then( (response) => {
            let dataResults = null;

            if (path.includes('tracks') && !isBaseRootApi) {
              dataResults = response.data.data;
            } else if ((path.includes('/v4/catalog/search/') && path.includes('tracks')) || (path.includes('/v4/my/default-cart/'))) {
              dataResults = response.data.tracks;
            } else if (path.includes('/catalog/v1/')) {
              const params = new URLSearchParams(path.split('?')[1]);
              dataResults = response.data;
              response.data.page = (response.data.page) ? response.data.page : params.get('page');
              response.data.per_page = (response.data.per_page) ? response.data.per_page : params.get('per_page');
            } else {
              dataResults = (path.includes('/v4/my/playlists')) ? response.data.results.map( x => { x.track.item_id = x.id; x.track.tombstoned = (x.tombstoned) ? x.tombstoned : null; return x.track } ) : response.data.results;
            }

            let dataResultsFormatted = customFormatData ? customFormatData(dataResults) : dataResults.map(isBaseRootApi ? Config.formattedFromBP: Config.formattedFromSearchV1);
            dataResultsFormatted = dataResultsFormatted.map(Config.rankingByPage(parseInt(response.data.page), parseInt(response.data.per_page)));

            const dataSpliced = [...dataResultsFormatted].splice(0, NB_ITEMS_BY_DEBOUNCE);
            globalStackItems[idParent] = dataResultsFormatted; // IMPORTANT - NEVER RE-RENDER
            globalStackFrom[from] = (globalStackFrom[from] && !globalStackFrom[from].includes(idParent)) ? [...globalStackFrom[from], idParent] : ( (!globalStackFrom[from]) ? [idParent] : globalStackFrom[from] ) ; // FOR SAME PARENT AND MERGE WITH SAME STACKAUTOMIX

            let next = response.data.next;
            if (!loadMoreWithApi && response.data.page && next) {
              const page = parseInt(response.data.page.split('/')[0]) + 1;
              if (page) {
                next = Config.API_URL + path + `&page=${page}`;
              }
            }
            setStoreList({
              itemsFull: dataResultsFormatted,
              total: dataResultsFormatted.length,
              items: [...dataSpliced],
              count: NB_ITEMS_BY_DEBOUNCE,
              next: next
            });
            globalNext[idParent] = next;

            if (from) {
              const newTracks = globalStackFrom[from].reduce( (base, idStack) => {
                if (idStack.toString().includes('recommended-tracks-from')) {
                  return [...base, ...globalStackItems[idStack].filter(x => !x.tombstoned).map(x => ({ ...x, recommended: true }))]
                } else {
                  return [...base, ...globalStackItems[idStack].filter(x => !x.tombstoned)]
                }
              }, [])
              const idPlaylistSelected = globalStackFrom[from].reduce( (base, idStack) => (!idStack.toString().includes('recommended-tracks-from')) ? idStack : base, idParent)
              dispatch(setStackAutomix({ idPlaylist: idPlaylistSelected, tracks: newTracks, from, active: 0, next: globalNext[idParent] }));
            }
            dispatch(setReadyBoostFilters( isBoost ? !!!response.data.next : true));
          })
          .catch( e => {
            if (e.constructor.name !== 'Cancel' && e.constructor.name !== 'r') {
              console.log('useApiOrLocal error', path, e, e.constructor.name); // todo - remove
            }
          } );

        }
    } else if (data) {
      const dataResultsFormatted = data.map((idParent === `search`) ? Config.formattedFromBP : Config.formatted);
      const dataSpliced = [...dataResultsFormatted].splice(0, NB_ITEMS_BY_DEBOUNCE);
      globalStackItems[idParent] = dataResultsFormatted; // IMPORTANT - NEVER RE-RENDER
      setStoreList({
        itemsFull: dataResultsFormatted,
        total: dataResultsFormatted.length,
        items: [...dataSpliced],
        count: NB_ITEMS_BY_DEBOUNCE,
        next: null
      });
    }

    return () => { source && source.cancel() } // Clean Axios

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, path, data, idParent, from, dispatch]); //warning storeList

  // EVERY ~20/30 frames
  useDebouncedEffect( () => {
    if (storeList.items && storeList.count < storeList.total && globalStackItems[idParent]) {
      const ii = [...globalStackItems[idParent]].splice(storeList.count, NB_ITEMS_BY_DEBOUNCE);
      setStoreList({
        ...storeList,
        items: [...storeList.items, ...ii],
        count: storeList.count + NB_ITEMS_BY_DEBOUNCE
      })
    }

    if (isBoost && storeList.total - storeList.count <= 10) { // IF BOOST AND ONLY MY PLAYLIST
      onLoadMore(storeList.count)();
    }

  }, (storeList.count < storeList.total) ? 50 : 3600000, [storeList])
  // 1000 / fps

  // Touch Mode - Double Tap or Normal Click
  const onClickItem = useCallback((item, e, index = null, touch = false) => {
    if (store.getState().allowAccess) {
      let itemx = [...(globalStackItems[idParent] ?? [])];
      if (e.drag) {
        const idx = index ?? itemx.findIndex(x => x.id === item.id);
        itemx = itemx.map((x, i) => i === idx ? { ...x, selected: true } : x);
      } else if (e.clear) {
        itemx = itemx.map(x => ({ ...x, selected: false }));
      } else if (e.shiftKey) {
        const idx = index ?? itemx.findIndex(x => x.id === item.id);
        const lastSelected = itemx.filter(x => x.selected).pop();
        const lastIDSelected = lastSelected ? lastSelected.id : item.id;
        const lastIndexSelected = itemx.findIndex(x => x.id === lastIDSelected);
        if (lastIndexSelected <= idx) {
          itemx = itemx.map((x, i) => (lastIndexSelected <= i && i <= idx) ? { ...x, selected: true } : x);
        } else {
          itemx = itemx.map((x, i) => (i <= lastIndexSelected && idx <= i) ? { ...x, selected: true } : x);
        }
      } else if (e.altKey || e.metaKey || touch) {
        const idx = index ?? itemx.findIndex(x => x.id === item.id);
        itemx = itemx.map((x, i) => i === idx ? { ...x, selected: !x.selected } : x);
      } else {
        const idx = index ?? itemx.findIndex(x => x.id === item.id);
        itemx = itemx.map((x, i) => ({ ...x, selected: i === idx, listParentId: idParent }));
      }
      globalStackItems[idParent] = itemx;
      dispatch(setSelectedItems(itemx.filter(x => x.selected)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParent, dispatch]);

  const allSelectedItems = useCallback(() => {
    const itemx = (globalStackItems[idParent] ?? []).map(x => ({ ...x, selected: true }));
    globalStackItems[idParent] = itemx;
    dispatch(setSelectedItems(itemx));
  }, [idParent, dispatch]);

  const unSelectedItems = useCallback(() => {
    if (!store.getState().touchEditor) { // Blur basic behavior
      dispatch(setSelectedItems([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParent, dispatch]);

  const end = useCallback(() => { // Only Drop Exterior or Escape
    // In case the drag start before the selection
    const state = getState();
    const selectedItems = state.selectedItems;
    selectedItems.forEach( x => {
      if (!x.selected) {
        const el = document.getElementById(`DI-${x.id}-TRACK`);
        if (el && el.classList.value.includes(`selected`)) {
          el.classList.remove(`selected`);
        }
      }
    })
    unSelectedItems();

    dispatch(clearDropbox());
    const ref = state.listContainerRef;
    if (ref && ref.current && ref.current.animFrameRef) {
      ref.current.scrollSpeedRef.current = 0;
      cancelAnimationFrame(ref.current.animFrameRef);
      ref.current.animFrameRef.current = null;
    } else if (ref && ref.animFrameRef) {
      ref.scrollSpeedRef.current = 0;
      cancelAnimationFrame(ref.animFrameRef);
      ref.animFrameRef.current = null;
    }

  }, [unSelectedItems, getState, dispatch])

  const forceUpdate = (newData) => {
    const stack = globalStackItems[idParent] ?? [];
    globalStackItems[idParent] = stack.map(x => {
      const newItem = newData.find(y => y.track_id === x.id);
      return newItem ? { ...x, item_id: newItem.item_id } : x;
    });
  }

  const onDropSortable = useCallback(( source, endIndex, afterSortable = () => {}) => (item) => {
    const state = getState();
    let selectedItems = state.selectedItems;
    const stack = globalStackItems[idParent] ?? [];

    let newItems = [];
    let newItemsForParent = [];
    if (source === item.idParent) { //SAME PARENT
      if (selectedItems.length === 1) {
        const startIndex = stack.findIndex(x => x.id === item.id);
        newItems = Config.reorder(stack.map(x => ({ ...x, selected: false })), startIndex, endIndex); // JUST ONE ELEMENT
      } else {
        const itemReference = stack.find((x, i) => i === endIndex + 1);
        const idsAvailable = selectedItems.map( x => x.id );
        newItems = stack.reduce( (b, x) => {
          if (!idsAvailable.includes(x.id)) { b.push(x) }
          return b;
        }, []);
        const startIndex = itemReference ? newItems.findIndex(x => x.id === itemReference.id) : newItems.length;
        newItems.splice(startIndex, 0, ...selectedItems.map(x => ({ ...x, selected: false })));
      }
    } else { // DIFFERENT PARENT
      selectedItems = state.dragItems;
      newItemsForParent = selectedItems.map( x => x.id );
      newItems = [...stack];
      newItems.splice(endIndex + 1, 0, ...selectedItems.map(x => ({ ...x, selected: false })));
    }

    globalStackItems[idParent] = newItems;
    setStoreList({
      ...storeList,
      itemsFull: [...newItems],
      total: newItems.length,
      items: [...newItems],
      count: newItems.length
    });

    afterSortable([...newItems], newItemsForParent, `update`, forceUpdate); //For parent like playlists, it will update the actual list but need to change the root
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParent]);

  // Touch - Move TOP OR BOTTOM
  const moveSortable = useCallback((top = true) => {
    const state = getState();
    const selectedItems = state.selectedItems;
    const stack = globalStackItems[idParent] ?? [];

    const idsAvailable = selectedItems.map( x => x.id );
    let newItems = stack.reduce( (b, x) => {
      if (!idsAvailable.includes(x.id)) { b.push(x) }
      return b;
    }, []);
    const startIndex = top ? 0 : newItems.length;
    newItems.splice(startIndex, 0, ...selectedItems.map(x => ({ ...x, selected: false })));

    globalStackItems[idParent] = newItems;
    setStoreList({
      ...storeList,
      itemsFull: [...newItems],
      total: newItems.length,
      items: [...newItems],
      count: newItems.length
    });

    api.patch(`/v4/my/playlists/${idParent}/tracks/bulk/`, { items: newItems.map((x,i) => ({ item_id: x.item_id, position: i + 1 })) }); // API
    dispatch(updateStorePlaylists(idParent, `tracks`, newItems)); //Local

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, idParent, dispatch]);

  const onLoadMore = useCallback((index) => () => {
    const itemx = globalStackItems[idParent] ?? [];
    const nextUrl = globalNext[idParent];
    if (!lockedRef.current && nextUrl) {
      if (index >= (itemx.length - (NB_ITEMS_BY_DEBOUNCE * 3) )) {
        lockedRef.current = true;
        if (api) {
          const nextPromise = nextUrl.includes('https') ? api.getFromURL(nextUrl) : api.getFromURI(nextUrl);

          nextPromise.then( (response) => {
            let dataResults = null;
            if (nextUrl.includes('/v4/catalog/search/') && nextUrl.includes('tracks')) {
              dataResults = response.data.tracks;
            } else {
              dataResults = (nextUrl.includes('/v4/my/playlists')) ? response.data.results.map( x => { x.track.item_id = x.id; return x.track } ) : response.data.results;
            }
            const dataResultsFormatted = [...itemx, ...dataResults.map(Config.formattedFromBP)]
            globalStackItems[idParent] = dataResultsFormatted;

            let next = response.data.next;
            if (!loadMoreWithApi && response.data.page && next) {
              const page = parseInt(response.data.page.split('/')[0]) + 1;
              if (page) {
                next = Config.API_URL + path + `&page=${page}`;
              }
            }

            setStoreList({
              itemsFull: dataResultsFormatted,
              total: dataResultsFormatted.length,
              items: [...itemx],
              count: itemx.length,
              next: next
            });
            globalNext[idParent] = next;
            lockedRef.current = false;

            dispatch(setReadyBoostFilters( isBoost ? !!!response.data.next : true));
          })
          .catch( e => console.log(`error - useApiOrLocal`, e) );
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParent, api, isBoost, from, dispatch, path]);

  const onDeleteItem = useCallback((index, afterDelete = null) => {
    const stack = [...(globalStackItems[idParent] ?? [])];
    const item_id = stack[index].item_id;
    stack.splice(index, 1);
    const newItems = stack.map(x => ({ ...x, selected: false }));
    globalStackItems[idParent] = newItems;
    setStoreList({
      itemsFull: [...newItems],
      total: newItems.length,
      items: [...newItems],
      count: newItems.length,
      next: null
    });
    if (afterDelete) {
      afterDelete([...newItems], [item_id], 'delete');
    }
  }, [idParent]);

  const onMassDelete = useCallback((ids, item_ids, afterDelete = null) => {
    let itemx = [...(globalStackItems[idParent] ?? [])];
    ids.forEach( id => {
      const index = itemx.findIndex( x => x.id === id )
      if (index >= 0) {
        itemx.splice(index, 1);
      }
    })
    const newItems = itemx.map(x => ({ ...x, selected: false }));
    globalStackItems[idParent] = newItems;
    setStoreList(stack => ({
      ...stack,
      itemsFull: [...newItems],
      total: newItems.length,
      items: [...newItems],
      count: newItems.length
    }));
    if (afterDelete) {
      afterDelete([...newItems], item_ids);
    }
  }, [idParent]);

  const storeX = {
    storeList,
    onClickItem,
    end,
    unSelectedItems,
    onDropSortable,
    onDeleteItem,
    onMassDelete,
    onLoadMore,
    allSelectedItems,
    moveSortable
  };

  useEffect(() => {
    if (createStore) {
      dispatch(setStoreListRedux(storeX));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeList]);

  return storeX;

};

export default useApiOrLocalV2;
